import React from 'react';
import { FullTable } from 'components';
import { ReportsBody, ReportsHead, ReportsNotYet } from './constants';
import { sortListByKey, useModal } from 'utils';
import { GenerateReport, systemReportEnums } from './core';

export const SystemReports = ({}) => {
    const { open } = useModal();

    const openGenerate = (item) => {
        open(<GenerateReport info={item?.generateInfo} />);
    };

    return (
        <div>
            <FullTable
                head={ReportsHead}
                body={ReportsBody(openGenerate)}
                list={sortListByKey(systemReportEnums, 'name')}
                notYet={ReportsNotYet('System')}
                activeRowId={''}
                margin={'0'}
            />
        </div>
    );
};
